import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/@mui+material@5.16.7_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1__@emotion+style_5fmx4zgukdrr7c4hrz6h7clcfi/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["MeProvider"] */ "/vercel/path0/packages/features/auth/src/providers/me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nClientProvider"] */ "/vercel/path0/packages/shared/i18n/src/provider/i18n-client.provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/datadog/rum-listener.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-form-stepper/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-gauge/nps-gauge.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-survey/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-textarea/nps-textarea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/relationship-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/transactional-modal/index.tsx");
